import React from "react";

export default function LoadingSpinner() {
    return (
        // <img src={ imagePlaceholder } width="100%" alt="Cover Photo" className="img-fluid" />
        <img src="https://via.placeholder.com/406x228?text=..." width="100%" alt="Cover Photo" className="img-fluid" />
    )
}
